export default "__VITE_ASSET__BMX3RNm1__"